import request from '@/utils/request'
 // 查询MPS基础数据维护列表
 export function apiScpSopMpsOptionsList (query) {
    return request({
      url: `/scp/scpSopMpsOptions/findPage`,
      method: 'get',
      params: query
    })
  }
   // 保存MPS选项
 export function apiSaveMpsOptions (query) {
    return request({
      url: `/scp/scpSopMpsOptions/saveMpsOptions`,
      method: 'post',
      data: query
    })
  }
// 查询MPS工作台计划列表
  export function ApiScpMpsPlansList (query) {
    return request({
      url: `/scp/scpMpsPlans/findPage`,
      method: 'get',
      params: query
    })
  }
  // 启动周配平
  export function ApiStartMpsPlanProcess (query) {
    return request({
      url: `/scp/scpMpsPlans/startMpsPlanProcess`,
      method: 'post',
      data: query
    })
  }
  // 删除MPS工作台计划
  export function ApiDeleteScpMpsPlans (id) {
    return request({
      url: `/scp/scpMpsPlans/delete/${id}`,
      method: 'get'
    })
  }
  // 关闭MPS工作台计划
  export function ApiCloseScpMpsPlans (id) {
    return request({
      url: `/scp/scpMpsPlans/close/${id}`,
      method: 'get'
    })
  }
  // 发布MPS工作台计划
  export function ApiPublishScpMpsPlans (id) {
    return request({
      url: `/scp/scpMpsPlans/publish/${id}`,
      method: 'get'
    })
  }
  // MPS工作台计划详情
  export function ApiScpMpsPlansDetail (id) {
    return request({
      url: `/scp/scpMpsPlans/detail/${id}`,
      method: 'get'
    })
  }
    // 停止计算
    export function ApiStopScpMpsPlans (id) {
      return request({
        url: `/scp/scpMpsPlans/terminationMpsPlan/${id}`,
        method: 'get'
      })
    }
  // 启动周配平
    export function ApiRunMpsProcess (id) {
      return request({
        url: `/scp/scpMpsPlans/runMpsProcess/${id}`,
        method: 'get'
      })
    }
      // 启动周平滑
      export function ApiRunMpsPlansSmooth (id) {
        return request({
          url: `/scp/scpMpsPlans/weekSmooth/${id}`,
          method: 'get'
        })
      }
            // 启动周平滑
      export function ApiListLockRulesForPlanSheet () {
        return request({
          url: `/scp/scpMpsPsLockedRules/listLockRulesForPlanSheet`,
          method: 'get'
        })
      }

// 导出
export function ApiExportScpMpsPlans (params) {
  return request({
    url: `/scp/scpMpsPlans/exportSupplierDetail`,
    method: 'post',
    data: params
  })
}
